import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {DealPayrollBreakdown} from '../models/deal-payroll.model';
import {Report} from '../models/report.model';
import {ApiConnectService} from './api-connect.service';
import {
  DEAL_PAYROLL_BREAKDOWN_PATH,
  DEAL_PAYROLL_GROUP_REPORT_PATH,
  DEAL_PAYROLL_MONTH_PARAM,
  DEAL_PAYROLL_PROGRESS_HEADER,
  DEAL_PAYROLL_REFRESH_PARAM
} from './deal-payroll.service.constants';
import {DealPayrollGroupReportRequest} from './deal-payroll.service.types';

export {DealPayrollGroupReportRequest} from './deal-payroll.service.types';

@Injectable()
export class DealPayrollService {
  constructor(private http: HttpClient, private api: ApiConnectService) {
  }

  getGroupPayrollReport(request: DealPayrollGroupReportRequest): Observable<Report[]> {
    let headers = new HttpHeaders({from: request.from, to: request.to});
    if (request.progressId) {
      headers = headers.set(DEAL_PAYROLL_PROGRESS_HEADER, request.progressId);
    }
    return this.http.get<Report[]>(
      this.api.dealPayrollGroup + request.groupId + DEAL_PAYROLL_GROUP_REPORT_PATH,
      {headers: headers});
  }

  getBreakdown(userId: string, month: string, refresh: boolean = false): Observable<DealPayrollBreakdown> {
    const params = new HttpParams()
      .set(DEAL_PAYROLL_MONTH_PARAM, month)
      .set(DEAL_PAYROLL_REFRESH_PARAM, String(refresh));
    return this.http.get<DealPayrollBreakdown>(
      this.api.dealPayrollReport + userId + DEAL_PAYROLL_BREAKDOWN_PATH,
      {params: params}
    );
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/deal-payroll.service.ts